export const getFullUrlPath = () => `${window.location.pathname}${window.location.search}`;